import { extractReasons } from '../utils/item';
import { useWorkflow } from '../workflow/hooks';

export const useReasons = () => {
  const { data, order } = useWorkflow();

  return {
    ...extractReasons({
      data,
      order,
    }),
  };
};
